<style scoped lang="scss" type="text/scss">
    .square-info-block-container{
        width: 15rem;
        height: 5rem;
        display: flex;
        align-items: flex-start;
        box-sizing: border-box;
        background-color: #F4F4F4;
        color: #666;
        border: .1rem solid transparent;
        padding: .5rem 1rem .5rem .5rem;
        margin-bottom: .5rem;
        transition: all .2s;

        &:last-of-type{
            margin-bottom: 0;
        }

        .left-panel{
            width: 4rem;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .icon {
                transition: all .2s;
                font-size: 2.2rem;
                text-align: center;
            }
        }

        &:hover,&.active {
            .left-panel .icon {
                color: #427DFF;
            }
        }

        .right-panel{
            height: 100%;
            flex: 1;
            flex-direction: column;
            display: flex;
            box-sizing: border-box;
            justify-content: center;
            .title {
                font-size: 1rem;
                display: flex;
                align-items: flex-end;
            }
            .description{
                opacity: .5;
                font-size: .75rem;
            }
        }
    }
</style>

<template>
    <angle-hover-card class="square-info-block-container" :class="{'active': active}" :active="active" :with-angle="withAngle">
        <div class="left-panel">
            <i class="icon" v-html="icon"></i>
        </div>
        <div class="right-panel">
            <span class="title">{{ title }}</span>
            <div class="description">
                <slot></slot>
            </div>
        </div>
    </angle-hover-card>
</template>

<script>
    import AngleHoverCard from '../angle-hover-card/index';

    export default {
        name: '',
        components: {
            AngleHoverCard
        },
        props: {
            active: {
                type: Boolean,
                default: false
            },
            icon: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: ''
            },
            withAngle: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {};
        }
    };
</script>
